export default async function getBasicData() {
  return [
    {
      key: 'inventorys_g',
      icon: 'fe fe-bookmark',
      url: '/inventories',
      permission: 'inventory_view',
    },
    {
      key: 'mainInventory',
      icon: 'fe fe-hard-drive',
      url: '/maininventories',
      permission: 'maininventory_view',
    },
    {
      key: 'addresss',
      icon: 'fe fe-home',
      url: '/addresses',
      permission: 'location_view',
    },
    {
      key: 'elin',
      icon: 'fe fe-shopping-cart',
      url: '/inventoryclasscosttypes',
      permission: 'inventoryclass_view',
    },
    {
      // "CLIN and Budget" - CLIN management lives inside this page now; the
      // separate CLIN menu item (/costtypes) was removed on purpose.
      key: 'clinBudgets',
      icon: 'fe fe-briefcase',
      url: '/clinBudgets',
      permission: 'clinbudget_view',
    },
    {
      key: 'inventoryclass',
      icon: 'fe fe-hard-drive',
      url: '/inventoryclasses',
      permission: 'inventoryclass_view',
    },
    {
      key: 'technicians',
      icon: 'fe fe-git-branch',
      url: '/technicians',
      permission: 'technician_view',
    },
    {
      key: 'parts',
      icon: 'fe fe-package',
      url: '/parts',
      permission: 'parts_view',
    },
    {
      key: 'suppliers',
      icon: 'fe fe-truck',
      url: '/suppliers',
      permission: 'supplier_view',
    },
    {
      key: 'contactPerson',
      icon: 'fe fe-user',
      url: '/contactPersons',
      permission: 'contact_view',
    },
    {
      key: 'intervals',
      icon: 'fe fe-clock',
      url: '/intervals',
      permission: 'interval_manage',
    },
    {
      key: 'contractYears',
      icon: 'fe fe-calendar',
      url: '/contractyears',
      permission: 'contract_edit',
    },
    {
      key: 'draftInventory',
      icon: 'fe fe-calendar',
      url: '/draftinventorylist',
      permission: 'draftinventory_view',
    },
    {
      key: 'workOrderCustomerStatuss',
      icon: 'fe fe-paper',
      url: '/workOrderCustomerStatusList',
      permission: 'workorder_view',
    },
  ]
}
